import { useMutation } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';
import { Form, Input, Button, Typography, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect, memo } from 'react';

import {
  PROFILE_QUERY,
  UPDATE_PROFILE,
} from '@marketreach/services/apollo/user';

import './styles.scss';

const { Text } = Typography;

const ProfileForm = (props) => {
  const { history } = props;
  const { user, logout } = useAuth0();

  const [formState, setFormState] = useState({
    email: user.email,
    password: '',
    newPassword: '',
    firstName: user.firstName,
    lastName: user.lastName,
  });

  const [updateProfile] = useMutation(UPDATE_PROFILE, {
    variables: {
      email: formState.email,
      password: formState.password,
      firstName: formState.firstName,
      lastName: formState.lastName,
      newPassword: formState.newPassword,
    },
    refetchQueries: [PROFILE_QUERY],
  });

  const isUnMounted = useRef(false);
  useEffect(() => {
    isUnMounted.current = false;
    return () => {
      isUnMounted.current = true;
    };
  }, []);

  const [form] = Form.useForm();

  const [error, setError] = useState('');
  const onFinish = async (values) => {
    setFormState({
      ...formState,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.currentPassword,
      newPassword: values.newPassword,
    });
    const result = await updateProfile();

    if (result.data.updateProfile.error) {
      setError(result.data.updateProfile.error);
    } else {
      setError('');
      message.info('Updated successfully');
      // setUser(result.data.updateProfile.data[0].user);
    }
  };

  const handleSignOut = async () => {
    logout({ returnTo: window.location.origin });
    // localStorage.removeItem(AUTH_TOKEN);
    // setUser(null);
    history.push('/login');
  };

  const gotoBack = () => {
    history.goBack();
  };

  return (
    <div className="profile-content">
      <Form
        form={form}
        name="profile"
        className="profile-form"
        onFinish={onFinish}
        scrollToFirstError
      >
        {error && <Text type="danger">{error}</Text>}
        <Form.Item name="firstName" initialValue={user.given_name}>
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item name="lastName" initialValue={user.family_name}>
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item
          name="email"
          initialValue={user.email}
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
            {
              required: true,
              message: 'Please input your E-mail!',
            },
          ]}
        >
          <Input placeholder="E-mail" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            className="profile-form-button"
            onClick={gotoBack}
          >
            Back to Dashboard
          </Button>
          <Button
            type="primary"
            className="profile-form-button"
            onClick={handleSignOut}
          >
            Sign out
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

ProfileForm.propTypes = {
  history: PropTypes.object,
};

ProfileForm.defaultProps = {
  history: undefined,
};

export default memo(ProfileForm);
